module.exports = __webpack_public_path__ + "selwebee_spt_bookbirthday-ENGLISH-540548c648d58ecf56c1ae2305a4d4b7.png";